export default __webpack_public_path__ + "d68f9be45893dbb9b82863ef4cd39a16.png";